/* eslint-disable no-unused-vars */

import _ from 'lodash';
import moment from 'moment';
import { getDataPoints, siteDisplayFieldForSearching } from '../../pages/settings/helper';
import { getTaskAssignedUserTags } from '../tasks/helper';
import { getAllWorkOrdersAndInspections } from './all-work-order-inspection-for-site';
import { attachMeta } from './attach-meta';

export const getSitesInfoForSitesListingPage = async ({
  parentSite = [],
  id = '',
  withChild = true,
  templatesIds = '',
  getDataFromCache,
  formWrapper = false,
  store,
  getWorkRequestData = false,
  siteTypeQuery = ''
}) => {
  const { tasks, cache, auth, settings, picklists, structure, pipeline } = store;
  const { sitesStructuresMap } = structure;
  const { sitePipelineCountMap } = pipeline;
  const { workOrderUsersMap, workOrderUsersGroupsMap } = tasks;
  const siteDisplayFields = settings.settings?.['siteDisplayFields'] || '';
  const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';
  const { picklistsMap = {}, areaHierarchyDataMap = {} } = picklists;
  const {
    equipmentsMap = {},
    sitesEquipmentsMap = {},
    equipments: cacheEquipments = [],
    syncedNewAndEditedEquipments = [],
    sites: cacheSites = []
  } = cache;

  let {
    assignedTasksList: allTasksList,
    hseEvents,
    newWorkRequestList,
    onDemandRecordList = [],
    newWorkOrderList
  } = !formWrapper && siteTypeQuery !== 'NewOrEditAsset'
    ? await getAllWorkOrdersAndInspections({
        templatesIds,
        getDataFromCache,
        store,
        getWorkRequestData,
        recordsCount: true,
        query: siteTypeQuery
      })
    : {
        assignedTasksList: [],
        hseEvents: [],
        newWorkRequestList: [],
        onDemandRecordList: [],
        newWorkOrderList: []
      };

  return new Promise((resolve) => {
    const sitesList =
      _.size(parentSite) > 0
        ? parentSite
        : !_.isEmpty(id)
        ? cacheSites?.filter((x) => x.siteId === id)
        : cacheSites;

    let prepareSites = [];

    const responsibleUsersMap = {
      ...(workOrderUsersMap || {}),
      ...(workOrderUsersGroupsMap || {})
    };

    const userId = auth.userId || '';

    let searchingSiteDataPoints = siteHiddenDisplayFields;

    for (let site of sitesList) {
      const { children = [] } = site;
      const parentSiteChildren =
        children?.map((childIndex) => {
          return { ...cacheSites[childIndex], children: [] };
        }) || [];

      let childrenData = [];
      if (site?.children?.length && !formWrapper) {
        childrenData = attachMeta(
          parentSiteChildren,
          sitesEquipmentsMap,
          equipmentsMap,
          allTasksList,
          cacheEquipments
        );
      }

      let allTasksForSite = [
        ...allTasksList.filter(
          (t) =>
            t?.siteId === site?.siteId ||
            t?.relatedAssetId === site.siteId ||
            t?.primaryAssetId === site.siteId ||
            t?.sites?.includes(site?.siteId)
        ),
        ...(withChild ? childrenData?.map((t) => t.allTasksForSite).flat(2) || [] : [])
      ];

      const allWorkRequestListSyncedAndInprogress = newWorkRequestList?.filter(
        (t) =>
          t?.siteId === site?.siteId ||
          t?.relatedAssetId === site.siteId ||
          t?.primaryAssetId === site.siteId ||
          t?.sites?.includes(site?.siteId) ||
          parentSiteChildren?.some((x) => x?.siteId === t?.siteId)
      );

      const alNewWorkOrderListSyncedAndInprogress = newWorkOrderList?.filter(
        (t) =>
          t?.siteId === site?.siteId ||
          t?.relatedAssetId === site.siteId ||
          t?.primaryAssetId === site.siteId ||
          t?.sites?.includes(site?.siteId) ||
          parentSiteChildren?.some((x) => x?.siteId === t?.siteId)
      );

      const allOnDemandRecordCount = onDemandRecordList?.filter(
        (t) =>
          t?.siteId === site?.siteId ||
          t?.relatedAssetId === site.siteId ||
          t?.primaryAssetId === site.siteId ||
          t?.sites?.includes(site?.siteId) ||
          (withChild && parentSiteChildren?.some((x) => x?.siteId === t?.siteId))
      );

      let hseEventsOfChild = hseEvents?.filter((t) => t?.siteId === site?.siteId);

      allTasksForSite = allTasksForSite?.map((tas) => {
        const { responsibleUsers = [], responsibleUserGroups = [] } = tas;
        const customAssignedTaskValue = getTaskAssignedUserTags({
          responsibleUsers,
          responsibleUserGroups,
          workOrderUsersGroupsMap,
          userId,
          responsibleUsersMap
        });

        return {
          customAssignedTaskValue,
          ...tas
        };
      });

      const allDoneTasks = allTasksForSite?.filter((task) => task?.status === 'Synced');
      const allotDoneTasks = allTasksForSite?.filter((task) => task?.status !== 'Synced');

      const today = moment().format('YYYY-MM-DD');
      const isOverDue = allotDoneTasks?.find((task) =>
        task.dueDate ? moment(task.dueDate).isBefore(today) : false
      );

      const dataPoints = getDataPoints(
        { ...site, type: site?.siteType },
        siteDisplayFields,
        'site',
        picklistsMap
      );

      const dataPointsForSearch = searchingSiteDataPoints
        ? getDataPoints(
            { ...site, type: site?.siteType },
            searchingSiteDataPoints,
            'site',
            picklistsMap
          )
        : [];

      let equipmentCountList = 0;
      let equipmentEditList = [];

      let parentSiteAndChildSiteIdsList = withChild
        ? [...(parentSiteChildren || []), ...[{ siteId: site.siteId }]]
        : [{ siteId: site.siteId }];

      const equipmentsEquipmentCategoryData = {},
        equipmentsEquipmentTypeData = {},
        equipmentListForTestingFilter = [];

      for (let x of parentSiteAndChildSiteIdsList) {
        let find = sitesEquipmentsMap[x?.siteId]?.length || 0;
        let equipmentIds = sitesEquipmentsMap[x?.siteId] || [];

        for (let equipmentId of equipmentIds) {
          const isEquipmentEdit =
            cacheEquipments[equipmentsMap[equipmentId]]?.equipmentEditingStatus || '';

          let syncedEquipment = syncedNewAndEditedEquipments?.filter(
            (y) => y?.siteId === x?.siteId && y?.equipmentId === equipmentId
          );
          // || !y.equipmentId

          if (isEquipmentEdit) {
            equipmentEditList.push(cacheEquipments[equipmentsMap[equipmentId]]);
          }
          if (syncedEquipment?.length > 0) {
            equipmentEditList = [...equipmentEditList, ...syncedEquipment];
          }

          // createEquipment category and type tags for filters testing
          if (
            // siteTypeQuery === 'NewOrEditAsset' &&
            isEquipmentEdit ||
            syncedEquipment?.length > 0
          ) {
            const equipmentValue = cacheEquipments[equipmentsMap[equipmentId]] || null;
            equipmentValue?.equipmentCategory &&
              !equipmentsEquipmentCategoryData[equipmentValue?.equipmentCategory] &&
              (equipmentsEquipmentCategoryData[equipmentValue?.equipmentCategory] = true);

            equipmentValue?.equipmentType &&
              !equipmentsEquipmentTypeData[equipmentValue?.equipmentType] &&
              (equipmentsEquipmentTypeData[equipmentValue?.equipmentType] = true);

            equipmentListForTestingFilter.push({
              equipmentId,
              equipmentCategory: equipmentValue?.equipmentCategory,
              equipmentType: equipmentValue?.equipmentType
            });
          }
        }

        let syncedEquipmentThatHaveSIteIdButNotApproved =
          syncedNewAndEditedEquipments?.filter((y) => y?.siteId === x?.siteId && !y?.equipmentId) ||
          [];

        // if (siteTypeQuery === 'NewOrEditAsset') {
        for (let syncedEquipmentCategory of syncedEquipmentThatHaveSIteIdButNotApproved) {
          syncedEquipmentCategory?.category &&
            !equipmentsEquipmentCategoryData[syncedEquipmentCategory?.category] &&
            (equipmentsEquipmentCategoryData[syncedEquipmentCategory?.category] = true);
          syncedEquipmentCategory?.typeId &&
            !equipmentsEquipmentTypeData[syncedEquipmentCategory?.typeId] &&
            (equipmentsEquipmentTypeData[syncedEquipmentCategory?.typeId] = true);

          equipmentListForTestingFilter.push({
            equipmentId: null,
            equipmentCategory: syncedEquipmentCategory?.category,
            equipmentType: syncedEquipmentCategory?.typeId
          });
        }
        // }

        equipmentEditList = [...equipmentEditList, ...syncedEquipmentThatHaveSIteIdButNotApproved];

        if (find) {
          equipmentCountList += find;
        }
      }

      let structureCountList = 0;

      for (let x of parentSiteAndChildSiteIdsList) {
        let find = sitesStructuresMap[x?.siteId]?.length || 0;
        if (find) {
          structureCountList += find;
        }
      }

      let pipelineCountList = 0;

      for (let x of parentSiteAndChildSiteIdsList) {
        let find = sitePipelineCountMap[x?.siteId]?.length || 0;
        if (find) {
          pipelineCountList += find;
        }
      }

      if (
        siteTypeQuery &&
        [
          'Check',
          'check',
          'Inspection',
          'inspection',
          'workOrder',
          'Work Order',
          'workRequest',
          'Work Request',
          'hseEvents'
        ].includes(siteTypeQuery)
      ) {
        equipmentEditList = 0;
      }
      prepareSites.push({
        ...site,
        status: !formWrapper ? site?.status : null,
        equipmentCount: !formWrapper ? equipmentCountList : 0,
        structureCount: !formWrapper ? structureCountList : 0,
        pipelineCount: !formWrapper ? pipelineCountList : 0,
        dataPoints,
        dataPointsForSearch,
        allDoneTasks: !getDataFromCache ? allDoneTasks : Array(allDoneTasks?.length).fill(1),
        isOverDue: !getDataFromCache ? isOverDue : Array(isOverDue?.length).fill(1),
        allTasksForSite: !getDataFromCache
          ? allTasksForSite
          : Array(allTasksForSite?.length).fill(1),
        allotDoneTasks: !getDataFromCache ? allotDoneTasks : Array(allotDoneTasks?.length).fill(1),
        hseEvents: hseEventsOfChild,
        soonestDueDate: _.min(
          allotDoneTasks.map((t) => t?.due || t?.dueDate).map((date) => new Date(date))
        ),
        allWorkRequestListSyncedAndInprogress,
        alNewWorkOrderListSyncedAndInprogress,
        allOnDemandRecordCount: allOnDemandRecordCount?.length || 0,
        equipmentEditList,
        siteAreaName:
          site?.areaHierarchy && areaHierarchyDataMap[site.areaHierarchy]
            ? areaHierarchyDataMap[site.areaHierarchy]
            : '',
        equipmentsEquipmentTypeData,
        equipmentsEquipmentCategoryData,
        equipmentListForTestingFilter
      });
    }

    return resolve(prepareSites);
  });
};
